/**
 * Generated by orval v8.5.3 🍺
 * Do not edit manually.
 * Rock&Run Admin API
 * OpenAPI spec version: 1.0
 */

export type MainBannerAdminControllerGetBannerItemsV1Type = typeof MainBannerAdminControllerGetBannerItemsV1Type[keyof typeof MainBannerAdminControllerGetBannerItemsV1Type];


export const MainBannerAdminControllerGetBannerItemsV1Type = {
  CONTEST: 'CONTEST',
  PROGRAM: 'PROGRAM',
} as const;
